import { CustomTab } from 'Components/molecules';
import { TRAINING_TABS } from 'Core-utils/constants/constants';
import { useEarlyAccess } from 'Hooks/useEarlyAccess';
import { useMemo } from 'react';

/**
 * Shared tab navigation for Training & Coaching pages (Security Tips, Browser Training,
 * Phishing Campaigns, Compliance Training). Tab visibility is driven by early-access (dev tier).
 */
const TrainingAndCoachingTabs = () => {
    const { isDevTier } = useEarlyAccess();

    const tabs = useMemo(
        () =>
            TRAINING_TABS.filter(
                (tab) =>
                    (tab.title === 'TRAINING_ANNUAL_COMPLIANCE_LABEL') ||
                    (isDevTier && tab.title === 'PHISHING_CAMPAIGNS_LABEL') ||
                    tab.title === 'SECURITY_TIPS_LABEL' ||
                    tab.title === 'BROWSER_COACHING_LABEL',
            ),
        [isDevTier],
    );

    return <CustomTab tabs={tabs} />;
};

export default TrainingAndCoachingTabs;
